import { render, staticRenderFns } from "./UpdatedAt.vue?vue&type=template&id=63e8b380&"
import script from "./UpdatedAt.vue?vue&type=script&lang=js&"
export * from "./UpdatedAt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports